module.exports = __webpack_public_path__ + "img/logo.23c1742b.png";